import { callUpdateSchedule } from "api/worker/schedule";
import { useModal } from "hooks/useModal";
import { robotKey } from "hooks/worker/keys";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { CleaningRobotItem } from "types/response/robot";
import { ScheduleItem } from "types/response/schedule";
import { UpdateScheduleRequest } from "types/schedule";
import { handleError } from "utils/error/handleError";

type UseEditModalProps = {
  afterCallback?: () => void;
};

export const useEditModal = ({ afterCallback }: UseEditModalProps) => {
  const modal = useModal();
  const [selectedSchedule, setSelectedSchedule] = useState<
    ScheduleItem | undefined
  >(undefined);
  const [isUpdating, setIsUpdating] = useState(false);
  const queryCleint = useQueryClient();

  const onUpdate = async (input: UpdateScheduleRequest) => {
    try {
      setIsUpdating(true);

      await callUpdateSchedule(input);

      queryCleint.setQueryData<CleaningRobotItem[] | undefined>(
        robotKey.list(),
        (prev) => {
          if (!prev) return prev;
          return prev.map((robot) => {
            if (robot.robotId !== input.robotId) return robot;
            robot.schedules = robot.schedules.map((s) => {
              if (s.scheduleId !== input.scheduleId) return s;
              return {
                ...input,
              };
            });
            return robot;
          });
        }
      );

      modal.onClose();

      if (afterCallback) afterCallback();
    } catch (err) {
      handleError(err);
    } finally {
      setIsUpdating(false);
    }
  };

  const onOpen = (schedule: ScheduleItem) => {
    setSelectedSchedule(schedule);
    modal.onOpen();
  };

  const onClose = () => {
    setSelectedSchedule(undefined);
    modal.onClose();
  };

  return {
    ...modal,
    onOpen,
    onClose,
    selectedSchedule,
    onUpdate,
    isUpdating,
  };
};
